<template lang="pug">
el-footer#site-footer(height="250")
  .page-width
    el-row
      el-col(:xs="24" :sm="4")
        .footer-section
          #logo #[img(src="@/assets/logo-white.png")]
      el-col(:span="12")
        .footer-section
          .nav-item Home
          .nav-item Community
          .nav-item Store
          .nav-item Blog
      el-col(:span="8")
        .footer-section
          .nav-item EDGEUNITE CO.
          .nav-item Contact
          .nav-item Privacy
          .nav-item Terms
    .clearfix
</template>

<script>
export default {
  name: "SiteFooter"
};
</script>

<style lang="stylus" scoped>
#site-footer {
  background-color: $color-footer;
}

.footer-section {
  padding: 20px;
  text-align: left;

  #logo {
    padding: 10px;

    img {
      height: 30px;
    }
  }

  .nav-item {
    color: white;
    font-size: 0.9em;
    font-weight: bold;
    padding: 10px;
  }
}
</style>
